import { request } from './apiClient'

export const fetchAdminStats = () => request('GET', '/v1/admin/stats')
export const fetchAdminUsers = () => request('GET', '/v1/admin/users')
export const fetchAdminUser = (id) => request('GET', `/v1/admin/users/${id}`)
export const updateAdminUser = (id, data) => request('PATCH', `/v1/admin/users/${id}`, data)
export const fetchAdminOrganisations = () => request('GET', '/v1/admin/organisations')
export const fetchAdminOrganisation = (id) => request('GET', `/v1/admin/organisations/${id}`)
export const updateAdminOrganisation = (id, data) => request('PATCH', `/v1/admin/organisations/${id}`, data)
export const fetchAdminTeam = (id) => request('GET', `/v1/admin/teams/${id}`)
export const bulkAddTeamMembers = (id, data) => request('POST', `/v1/admin/teams/${id}/members/bulk-add`, data)
export const bulkSetTeamMemberRole = (id, data) => request('POST', `/v1/admin/teams/${id}/members/bulk-set-role`, data)
export const bulkRemoveTeamMembers = (id, data) => request('POST', `/v1/admin/teams/${id}/members/bulk-remove`, data)
export const fetchAdminConversations = () => request('GET', '/v1/admin/conversations')
export const fetchAdminEngines = () => request('GET', '/v1/admin/engines')
export const fetchAdminFolderMappings = () => request('GET', '/v1/admin/folder-mappings')
export const fetchAdminPricing = () => request('GET', '/v1/admin/pricing')
export const fetchAdminAgentSessions = () => request('GET', '/v1/admin/agent-sessions')
export const fetchAdminFiles = () => request('GET', '/v1/admin/files')
export const fetchAdminTasks = () => request('GET', '/v1/admin/tasks')
export const fetchAdminFileSpreadsheet = (id) => request('GET', `/v1/admin/files/${id}/spreadsheet`)
export const preprocessAdminFile = (id) => request('POST', `/v1/admin/files/${id}/preprocess`)
export const fetchAdminAgentSession = (id) => request('GET', `/v1/admin/agent-sessions/${id}`)

export const createAdminEngine = (data) => request('POST', '/v1/admin/engines', data)
export const updateAdminEngine = (id, data) => request('PATCH', `/v1/admin/engines/${id}`, data)
export const deleteAdminEngine = (id) => request('DELETE', `/v1/admin/engines/${id}`)

export const fetchAdminPrompts = () => request('GET', '/v1/admin/prompts')
export const fetchAdminPrompt = (id) => request('GET', `/v1/admin/prompts/${id}`)
export const createAdminPrompt = (data) => request('POST', '/v1/admin/prompts', data)
export const updateAdminPrompt = (id, data) => request('PATCH', `/v1/admin/prompts/${id}`, data)
export const deleteAdminPrompt = (id) => request('DELETE', `/v1/admin/prompts/${id}`)

export const fetchAdminAgentSessionQAList = (sessionId) =>
  request('GET', `/v1/admin/agent-sessions/${sessionId}/qa`)

export const fetchAdminAgentSessionQAConversation = (sessionId, convId) =>
  request('GET', `/v1/admin/agent-sessions/${sessionId}/qa/${convId}`)

export const updateAdminAgentSessionQATitle = (sessionId, convId, title) =>
  request('PATCH', `/v1/admin/agent-sessions/${sessionId}/qa/${convId}`, { title })

export async function startAdminAgentSessionQA(sessionId, message) {
  const { headers, API_BASE_URL } = await import('./apiClient')
  const response = await fetch(`${API_BASE_URL}/v1/admin/agent-sessions/${sessionId}/qa`, {
    method: 'POST',
    headers: headers(),
    body: JSON.stringify({ message }),
  })
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || `HTTP ${response.status}`)
  }
  return response
}

export async function continueAdminAgentSessionQA(sessionId, convId, message) {
  const { headers, API_BASE_URL } = await import('./apiClient')
  const response = await fetch(
    `${API_BASE_URL}/v1/admin/agent-sessions/${sessionId}/qa/${convId}`,
    {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify({ message }),
    }
  )
  if (!response.ok) {
    const data = await response.json().catch(() => ({}))
    throw new Error(data.error || `HTTP ${response.status}`)
  }
  return response
}

// Stock plans (staff today; see CanManageStockPlan on the backend)
export const fetchAdminStockPlans = () => request('GET', '/v1/admin/stock-plans/')
export const fetchAdminStockPlanMeta = () => request('GET', '/v1/admin/stock-plans/meta')
export const fetchAdminStockPlan = (id) => request('GET', `/v1/admin/stock-plans/${id}/`)
export const createAdminStockPlan = (data) => request('POST', '/v1/admin/stock-plans/', data)
export const updateAdminStockPlan = (id, data) => request('PATCH', `/v1/admin/stock-plans/${id}/`, data)
export const deleteAdminStockPlan = (id) => request('DELETE', `/v1/admin/stock-plans/${id}/`)
export const importAdminStockPlan = (id) => request('POST', `/v1/admin/stock-plans/${id}/import`)
export const fetchAdminStockPlanImageUrls = (id, overwrite = false) =>
  request('POST', `/v1/admin/stock-plans/${id}/fetch-image-urls`, { overwrite })
export const downloadAdminStockPlanImages = (id, overwrite = false) =>
  request('POST', `/v1/admin/stock-plans/${id}/download-images`, { overwrite })
export const testAdminStockPlanMapping = (id, data) =>
  request('POST', `/v1/admin/stock-plans/${id}/test-mapping`, data)
export const fetchAdminStockPlanItems = (id, { q = '', status = 'active', limit = 100 } = {}) =>
  request('GET', `/v1/admin/stock-plans/${id}/items/?q=${encodeURIComponent(q)}&status=${status}&limit=${limit}`)

// Per-métier stock-plan assignment for one user (staff)
export const fetchAdminUserStockPlans = (userId) =>
  request('GET', `/v1/admin/users/${userId}/stock-plan`)
export const setAdminUserStockPlan = (userId, metier, planId) =>
  request('PUT', `/v1/admin/users/${userId}/stock-plan`, { metier, plan_id: planId })
export const clearAdminUserStockPlan = (userId, metier) =>
  request('DELETE', `/v1/admin/users/${userId}/stock-plan?metier=${encodeURIComponent(metier)}`)
